// extracted by mini-css-extract-plugin
export default {"title":"ApproveUsersPage_title__1u9-5","pageContainer":"ApproveUsersPage_pageContainer__CgRVQ"};